


<div class="card margin-top-16px">
  <div class="card-header wh-header card-title-schedule-bl font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
    Functions &amp; Features
  </div>
  <div class="card-body">

    <div class="row margin-right-0px">

      <div class="col-md-12">


        <div class="row margin-left-0px">
          <div class="col-md-3  border-all padding-left-0px padding-right-0px margin-right-10px" hidden>
            <div class="card">
              <div class="card-header wh-header card-title-7px font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb font-size-14">
                Plan Status
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Active</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">120</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>New</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Closed</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">8</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 border-all padding-left-0px padding-right-0px margin-right-10px" hidden>
            <div class="card">
              <div class="card-header wh-header card-title-7px font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb font-size-14">
                Activity Tracking

              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Scheduled</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Rescheduled</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Discussed</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <!--<div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Over Due</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>-->
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Over Due</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Not Reachable</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>No Answer</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Completed</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 text-align-right">
                    <label>Cancelled</label>
                  </div>:
                  <div class="col-md-5">
                    <label class="color-Assign">10</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4  border-all padding-left-0px padding-right-0px margin-right-10px" hidden>
            <div class="card">
              <div class="card-header wh-header card-title-7px font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb font-size-14">
                Estimated Potential
              </div>
              <div class="card-body">
                <div class="border-all margin-bottom-10px border-radius-5px">
                  <div class="row margin-left-0px ">

                    <div><label class="margin-left-5px">Affortable</label></div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 text-align-right">
                      <label>Leads</label>
                    </div>:
                    <div class="col-md-5">
                      <label class="color-Assign">5</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 text-align-right">
                      <label>Projection</label>
                    </div>:
                    <div class="col-md-5">
                      <label>1,00,000</label>
                    </div>
                  </div>
                </div>
                <div class="border-all border-radius-5px">
                  <div class="row margin-left-0px ">

                    <div><label class="margin-left-5px">Other</label></div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 text-align-right">
                      <label>Leads</label>
                    </div>:
                    <div class="col-md-5">
                      <label class="color-Assign">5</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 text-align-right">
                      <label>Projection</label>
                    </div>:
                    <div class="col-md-5">
                      <label>2,50,000</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">

        </div>
        <div class="row margin-left-zero">
          <div class="col-md-3 padding-right-0px">

            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">Registration</li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Registration All Patients')">
                <a class="nav-link-hand text-decoration color-data2 font-size-14 nav-reg"
                   (click)="OpenModal()">
                  <i class="fas fa-plus "></i> New
                </a>
              </li>

              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Patients List')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/dashboard']">
                  Patients List

                </a>
              </li>

            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">Follow Up</li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px">
                <a class="nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/counsellingregister']">
                  Counselling Register
                </a>
              </li>

              <li class="font-size-14 margin-top-5px margin-bottom-5px">
                <a class="nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/dailyworkbook']">
                  Daily Work Book
                </a>
              </li>
              <li class="font-size-14"><a class="text-decoration color-lightgray font-size-14"> Reports</a></li>

            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">
                Appointments


              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Registration Appointments')">
                <a class="nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/fdappoinment']">

                  Book Appointments
                </a>
              </li>

              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Cancel Appointments
                </a>
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Patient Visit Register')">
                <a class="nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/visitreg']">
                  Visit Register
                </a>
              </li>

            </ul>
          </div>

          <div class="col-md-3 padding-left-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">
                Billing(Pharmacy)

              </li>
              <li class="font-size-14">

                <a class="text-decoration color-lightgray font-size-14">

                  New Bill
                </a>
              </li>

              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  View Bills
                </a>
              </li>

              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Refund
                </a>
              </li>
            </ul>
          </div>


        </div>
        <div class="row margin-left-zero">
          <div class="col-md-3 padding-right-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">
                Billing(OP)

              </li>
              <!--<li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="TestVersion">
    <a class="nav-link-hand text-decoration color-data2 font-size-14 nav-reg"
       (click)="OpenBill()">
      <i class="fas fa-plus "></i> New Bill
    </a>
  </li>

  <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="TestVersion">
    <a class=" nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/opbilling']">
      View Bills
    </a>
  </li>-->
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('IP Bill')">
                <a class="nav-link-hand text-decoration color-data2 font-size-14 nav-reg"
                   (click)="OpenBill()">
                  <i class="fas fa-plus "></i> New Bill
                </a>
              </li>

              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Bills')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/opbilling']">
                  View Bills
                </a>
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Bills')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/itemcatalogue']">
                  Catalogue
                </a>
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Bills')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/customerorders']">
                  Customer Orders
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Advances
                </a>
              </li>
              <!--<li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Refund
                </a>
              </li>-->
            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">
                Lab

              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">

                  Order Request
                </a>
              </li>

              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('Specimen Collection')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new" [routerLink]="['/healins/lab']">

                  Specimen Collections
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Results
                </a>
              </li>

            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">

            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">In Patient</li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Admissions
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Billing
                </a>
              </li>
              <li class="font-size-14">
                <a class="  text-decoration color-lightgray font-size-14">
                  Discharges

                </a>
              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">
                  Transfers

                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">

            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">EHR</li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px">
                <a class="text-decoration color-lightgray font-size-14 ">
                  <i class="fas fa-plus "></i> Add Record
                </a>
              </li>



            </ul>
          </div>



        </div>
        <div class="row margin-left-zero">
          <div class="col-md-3 padding-right-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">IVF</li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  <i class="fas fa-plus margin-right-3px"></i>New Cycle
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Donors
                </a>
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('All Treatment Cycles List')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/ivfdashboard']">
                  Treatment Cycles

                </a>
                <!--<a class=" text-decoration color-lightgray font-size-14">
      Treatment Cycle
    </a>-->
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('All Treatment Cycles List')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/ivfdashboard2']">
                  Treatment Cycles(Adv)

                </a>
                <!--<a class=" text-decoration color-lightgray font-size-14">
      Treatment Cycle
    </a>-->
              </li>
              <li class="font-size-14 margin-top-5px margin-bottom-5px" [hidden]="!HasAccess2('IVF Workbench')">
                <a class=" nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/ivfworkbench']">
                  Ivf Work Bench

                </a>
                <!--<a class=" text-decoration color-lightgray font-size-14">
      Treatment Cycle
    </a>-->
              </li>
            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">
                ERP

              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">

                  Purchases
                </a>
              </li>

              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Stores
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Stock Adjustments
                </a>
              </li>

            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">

            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">Events</li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Registration
                </a>
              </li>

              <li class="font-size-14">
                <a class="  text-decoration color-lightgray font-size-14">
                  Events

                </a>
              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">
                  Participant Types

                </a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 padding-left-0px">

            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">Finance</li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Expenses
                </a>
              </li>

              <li class="font-size-14">
                <a class="  text-decoration color-lightgray font-size-14">
                  Account

                </a>
              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">
                  Account Books

                </a>
              </li>
              <li class="font-size-14">
                <a class="text-decoration color-lightgray font-size-14">
                  Account Groups

                </a>
              </li>
            </ul>
          </div>

        </div>
        <div class="row margin-left-zero">
          <div class="col-md-3 padding-right-0px">
            <ul class="padding-left-0px margin-top-10">
              <li class="font-size-16px color-Assign">Others</li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Blood Bank
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Nursing Station
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  CSSD
                </a>
              </li>
              <li class="font-size-14">
                <a class=" text-decoration color-lightgray font-size-14">
                  Canteen
                </a>
              </li>

            </ul>
          </div>


        </div>
      </div>
      <div class="col-md-3 border-all padding-left-0px padding-right-0px" hidden>
        <div class="card">
          <div class="card-header wh-header card-title-7px font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb font-size-14">
            Short cut
          </div>
          <div class="card-body">
            <ul class="padding-left-0px padding-bottom-0px">
              <li>
                <a class="nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/counsellingregister']">
                  Counselling Register
                </a>
              </li>
              <li>
                <a class="nav-link-hand text-decoration color-data2 nav-new"
                   [routerLink]="['/healins/activitytracking']">
                  Activities Tracking
                </a>
              </li>
              <li><a class="nav-link-hand text-decoration color-data2 nav-new">Reports</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>



<router-outlet></router-outlet>
